import(/* webpackMode: "eager", webpackExports: ["CryptoRatesTable"] */ "/app/app/(finance)/finance/components/crypto/CryptoRatesTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsDynamic"] */ "/app/app/components/BreadcrumbsDynamic.tsx");
